// Homepage for NPC Buyer’s Agency Website
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import LightweightClientBriefForm from "./components/LightWeightClientBriefForm";
import NPCDetailedListingsPage from './components/NPCDetailedListingPage';
import PropertyAssetMatrix from "./components/PropertyAssetMatrix";
import StrategyComparison from "./components/StrategyComparison";
import JoinPage from './pages/JoinPage';
import LoginPage from "./pages/LoginPage";
import StrategyIframePage from "./pages/Strategy";
import SubmitBriefIframePage from "./pages/SubmitBriefIframePage";
import CashflowIframePage from "./pages/CashflowIframePage"
import BuyersAgencyProposalPage from "./pages/BuyersAgencyProposalPage";
import ProtectedRouteNPC from './components/ProtectedRouteNPC';
import PrivacyPolicy from './components/PrivacyPolicy';
import NPCBookingLanding from './components/NPCOffmarketCampaign/NPCBookingLanding';


function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/case-studies" element={<CaseStudiesPage />} />
        <Route path="/brief" element={<LightweightClientBriefForm />} />
        <Route path="/offmarket-properties" element={<NPCDetailedListingsPage />} /> {/* 👈 New route */}
        <Route path="/property-assets" element={<PropertyAssetMatrix />} /> {/* 👈 New route */}
        {/* <Route path="/strategy" element={<StrategyRecommendation />} /> 👈 New route */}
        <Route path="/strategy-comparison" element={<StrategyComparison />} /> {/* 👈 New route */}
        <Route path="/join" element={<JoinPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/strategy"
          element={
            <ProtectedRouteNPC>
              <StrategyIframePage />
            </ProtectedRouteNPC>
          }
        />
        <Route path="/submit-brief" element={<SubmitBriefIframePage />} />
        <Route path="/buyers-agency-proposal" element={<BuyersAgencyProposalPage />} />
        <Route path="/private/julia-townsville-proposal" element={<BuyersAgencyProposalPage />} />
        <Route path="/property-investment-calculators" element={<CashflowIframePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/npc" element={<NPCBookingLanding />} />

      </Routes>

      <Footer />
      {/* <ExitIntentLeadForm /> */}
    </Router>
  );
}

export default App;
